import {ArtifactoryDao} from '../artifactory_dao';

export function BinaryProvidersInfoDao(RESOURCE, ArtifactoryDaoFactory) {
    return ArtifactoryDaoFactory()
            .setPath(RESOURCE.BINARY_PROVIDERS_INFO)
            .setCustomActions({
                'get':{
                    method: 'GET'
                }
            });
}


// WEBPACK FOOTER //
// ./data/dao/binary_providers_info_dao.js